<template>
  <div class="mod-article-inner">
    <preview-job-content-header
      v-if="title"
      :title="title"
    />

    <p
      class="pega-mb-0"
      :class="{'pega-workstyle-label-area-sp': isWorkstyle}"
      data-test="text"
    >
      {{ text }}
    </p>
    <p
      class="pega-pre-wrap pega-break"
      data-test="remarks"
      v-text="remarks"
    />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import PreviewJobContentHeader from '@/components/atoms/PreviewJobContentHeader'

export default {
  components: {
    PreviewJobContentHeader
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    remarks: {
      type: String,
      default: ''
    },
    isWorkstyle: {
      type: Boolean,
      default: false
    }
  }
}
</script>
